import Svg, { Path } from 'react-native-svg'

export const BillPaymentRupeeIcon = ({ color = '#966D2E', width = 24, height = 24 }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M16 7h4a2 2 0 0 0-.59-1.41l-3-3A2 2 0 0 0 15 2v4a1 1 0 0 0 1 1Zm-2.12 1.12A3 3 0 0 1 13 6V2H6.5A2.49 2.49 0 0 0 4 4.5v15A2.49 2.49 0 0 0 6.5 22h11a2.49 2.49 0 0 0 2.5-2.5V9h-4a3 3 0 0 1-2.12-.88ZM14 14a3 3 0 0 1-1.11 2.33l1.56.78A1 1 0 0 1 14 19a.929.929 0 0 1-.45-.11l-4-2A1 1 0 0 1 10 15h1a1 1 0 1 0 0-2H9a1 1 0 1 1 0-2h5a1 1 0 0 1 0 2h-.18a3 3 0 0 1 .18 1Z"
      />
    </Svg>
  )
}
